/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

/**
 * Converts string to camelcase
 */
export function snakeToCamelCase(str: string) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}
